export default __webpack_public_path__ + "static/media/volunteer.b59e1275.jpg";